/* eslint-disable react/function-component-definition */
import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
} from 'react-router-dom';

import {
  ENDPOINT_SECURITY,
  ENDPOINT_REQUEST_WORKSPACE,
  ENDPOINT_CONTRIBUTE_DATA,
  ENDPOINT_DUP_PDF,
} from 'env-create-react-app';

import Header from './components/Header';
import Announcements from './components/Announcements/Announcements';
import Overview from './components/Overview';
import Content from './components/Content';
import Security from './components/Security';
import RequestWorkspace from './components/RequestWorkspace';
import dupPdf from './docs/RDCA-DAP_Data_Use_Agreement_2022.pdf';

import ContributeData from './components/ContributeData';

const App = () => (
  <>
    <Header />
    <div id="announcement">
      <Announcements />
    </div>
    <div id="flex">
      <Router>
        <AppContentRouter />
      </Router>
    </div>
  </>
);

const AppContentRouter = () => {
  const { pathname } = useLocation();

  return (
    <Switch>
      <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
      <Route exact path={ENDPOINT_SECURITY}>
        <Security />
      </Route>
      <Route exact path={ENDPOINT_REQUEST_WORKSPACE}>
        <RequestWorkspace />
      </Route>
      <Route exact path={ENDPOINT_CONTRIBUTE_DATA}>
        <ContributeData />
      </Route>
      <Route exact path={ENDPOINT_DUP_PDF}>
        <div style={{ position: 'relative', width: '100%', height: 'calc(100vh - 4rem)' }}>
          <object data={dupPdf} type="application/pdf" width="100%" height="100%">
            <embed src={dupPdf} type="application/pdf" width="100%" height="100%" />
          </object>
        </div>
      </Route>
      <Route exact path="/">
        <Overview />
        <Content />
      </Route>
      <Redirect to="/" />
    </Switch>
  );
};

export default App;
